import { style, stylesheet } from 'typestyle';
import { Blood, Blue, Gold, Gray, GrayDark } from './colors';
export const titleStyle = stylesheet({
    common: {
        position: 'absolute',
        paddingTop: 4,
        left: 12,
        zIndex: 1,
        color: GrayDark,
    },
    focused: { color: `${Blue} !important` },
    error: { color: `${Blood} !important` },
    warning: { color: `${Gold} !important` },
});
export const inputLineHeight = 14;
export const errMsgStyle = style({
    color: Blood,
    lineHeight: `${inputLineHeight}px`,
    marginTop: 2,
    marginLeft: 12,
});
export const warnMsgStyle = style({
    color: Gold,
    lineHeight: `${inputLineHeight}px`,
    marginTop: 2,
    marginLeft: 12,
});
export const inputContainerStyle = style({
    position: 'relative',
    minHeight: 40,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
});
export const borderPx = 1.5;
export const inputPaddingPx = 12;
export const inputDefaultBorderColor = Gray;
export const leftPaddingStyle = style({
    paddingLeft: inputPaddingPx,
});
//# sourceMappingURL=input.js.map